import { useNavigate } from "react-router-dom";
import { ArrowRight, Quote } from "lucide-react";
import { IMAGES } from "../data/content";
import { Reveal } from "../lib/motion";
import { t } from "../i18n";

const AboutSection = () => {
  const navigate = useNavigate();
  return (
    <section id="about" data-testid="about-section" className="relative py-24 lg:py-32 bg-navy-deep overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <Reveal className="relative">
            <div className="relative">
              <div className="absolute -top-5 -left-5 h-full w-full rounded-2xl border border-gold/30" />
              <img
                src={IMAGES.aboutMain}
                alt="Traveller preparing for an international journey"
                className="relative rounded-2xl object-cover h-[420px] sm:h-[520px] w-full shadow-2xl"
              />
              <img
                src={IMAGES.aboutSecondary}
                alt="World map marking global destinations"
                className="absolute -bottom-10 -right-4 sm:-right-10 w-40 sm:w-56 rounded-xl border-4 border-navy-deep shadow-2xl object-cover h-32 sm:h-40"
              />
            </div>
          </Reveal>
          <div>
            <Reveal>
              <p className="text-xs sm:text-sm font-semibold tracking-[0.3em] uppercase text-gold mb-4 font-display">
                {t("about.eyebrow")}
              </p>
              <h2 className="font-display font-extrabold tracking-tight text-3xl sm:text-4xl lg:text-5xl text-white leading-[1.08]" data-testid="about-heading">
                {t("about.title1")}
                <br />
                <span className="gold-gradient-text">{t("about.title2")}</span>
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-6 text-slate-400 leading-relaxed">
                {t("about.p1")}
              </p>
              <p className="mt-4 text-slate-400 leading-relaxed">
                {t("about.p2")}
              </p>
            </Reveal>
            <Reveal delay={0.2} className="mt-8 glass-card rounded-xl p-6 border-l-2 border-l-gold">
              <Quote className="h-5 w-5 text-gold mb-3" />
              <p className="text-sm text-slate-300 leading-relaxed italic">
                "{t("about.quote")}"
              </p>
              <p className="mt-4 font-display font-bold text-white text-sm tracking-wide">
                {t("about.founder")}
                <span className="block text-xs font-medium text-gold tracking-[0.2em] mt-1">{t("about.founderRole")}</span>
              </p>
            </Reveal>
            <Reveal delay={0.3}>
              <button
                onClick={() => navigate("/about")}
                data-testid="about-learn-more-btn"
                className="mt-8 btn-gold rounded-full px-8 py-4 text-sm font-bold tracking-wider font-display inline-flex items-center gap-2"
              >
                {t("about.learnMore")} <ArrowRight className="h-4 w-4" />
              </button>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
